<template>
  <div class="relative">
    <Header />
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <div
      class="container mx-auto max-w-[1200px] w-full py-7 flex flex-col gap-10 px-4 md:px-6 lg:gap-16"
    >
      <div class="min-h-screen w-full container-default-1209px w-container">
        <div class="flex gap-6 justify-end py-5">
          <!-- <div
              class="mb-1 w-16 cursor-pointer rounded-lg flex border justify-center gap-2 items-center p-1 bg-white text-sm text-gray-700 hover:text-teal-500"
              @click="genaicourse = true"
            >
              Edit
            </div> -->
          <div
            class="mb-1 cursor-pointer w-36 rounded-lg flex border justify-center gap-2 items-center p-1 bg-white text-sm text-gray-700 hover:text-teal-500"
            @click="convertcourse"
          >
            Course converter
          </div>

          <div @click="goBack" class="">
            <div
              class="mb-1 cursor-pointer rounded-lg flex border justify-center w-24 gap-2 items-center py-1 bg-white"
            >
              <div
                class="text-sm text-gray-700 hover:text-teal-500"
                title="back"
              >
                back
              </div>
              <div class="flex items-center">
                <img
                  src="https://img.icons8.com/external-simple-solid-edt.graphics/15/undefined/external-Back-arrows-simple-solid-edt.graphics-2.png"
                />
              </div>
            </div>
          </div>
        </div>

        <div v-if="genaicourse" class="hidden">
          <form @submit.prevent="genaicourseedit" class="border p-5">
            <div class="col-start-1 col-end-4">
              <label for="description">
                Description<span class="text-red-400">*</span>
              </label>

              <div class="h-[40%] w-full">
                <v-md-editor
                  id="sample"
                  v-model="markdown"
                  left-toolbar="undo redo clear| tip todo-list | h bold italic strikethrough quote | ul ol table hr | link image code | save"
                  :source="markdown"
                  height=""
                  class="col-span-2 mt-4 border border-gray-300 rounded-md w-full"
                >
                </v-md-editor>
              </div>
            </div>
            <div class="flex justify-between items-center py-2 lg:py-4">
              <div>
                <p class="text-green-400 text-xl" v-if="message">
                  {{ message }}
                </p>
              </div>
              <div class="flex justify-end">
                <button class="px-4 py-2 gradient-btn rounded-lg" type="sumbit">
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>

        <!-- Loading -->
        <div
          v-if="loading"
          class="flex items-center justify-center min-h-[300px] md:min-h-[400px]"
        >
          <img src="@/assets/newd/loading.gif" alt="Loading..." />
        </div>

        <div class="overflow-y-auto" v-else-if="popupData2.course != null">
          <markdown-preview
            v-if="popupData2.course"
            :source="popupData2.course"
          />
        </div>
        <div v-else class="text-lg font-normal text-center">No data found</div>
        <!-- convert popup -->

        <div
          v-if="convertpopup"
          class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
        >
          <div
            class="lg:w-[40%] bg-white rounded-xl p-10 overflow-y-auto max-h-[900px]"
          >
            <div class="flex items-center justify-between">
              <h3 class="text-lg font-bold text-blues">Course</h3>
              <img
                src="@/assets/newd/close.png"
                class="cursor-pointer"
                alt=""
                @click="convertpopup = false"
              />
            </div>

            <div class="w-full mt-2 flex flex-col relative rounded-2xl">
              <div class="w-full">
                <form
                  ref="addCourseRef"
                  @submit.prevent="createCourse"
                  class="flex flex-col gap-4 text-xs md:text-sm h-full"
                >
                  <div class="parent flex flex-col gap-2">
                    <div class="flex flex-col gap-2">
                      <label for="title">
                        Title<span class="text-red-400">*</span>
                      </label>
                      <input
                        id="title"
                        type="text"
                        required
                        v-model="conversion_title"
                        class="border border-gray-300 rounded-md text-sm w-full p-2"
                      />
                    </div>

                    <div class="flex flex-col gap-2 hidden">
                      <label for="description">
                        Description<span class="text-red-400">*</span>
                      </label>

                      <div class="w-full border">
                        <!-- <textarea
                          id="description_markdown"
                            v-model="markdown"
                            
                            class="min-h-screen border rounded-l-md border-gray-300"
                          />
                          <markdown-preview
                            :source="markdown"
                            id="right_markdown"
                          
                            class="h-screen overflow-y-auto border rounded-r-md border-gray-300 w-full"
                          ></markdown-preview>  -->
                        <!-- <v-md-editor
                            id="sample"
                            v-model="markdown"
                            left-toolbar="undo redo clear| tip todo-list | h bold italic strikethrough quote | ul ol table hr | link image code | save"
                            :source="markdown"
                            height="700px"
                            class="col-span-2 mt-4 border border-gray-300 rounded-md w-full"
                          >
                          </v-md-editor> -->

                        <QuillEditor
                          style="height: 150px"
                          theme="snow"
                          class=""
                          id="sample"
                          v-model="markdown"
                          toolbar="full"
                          :content="markdown"
                          contentType="html"
                        />
                      </div>
                    </div>

                    <div class="flex flex-col gap-2">
                      <label for="thumbnail"> Thumbnail </label>
                      <input
                        id="thumbnail"
                        type="file"
                        @change="handleFileUpload"
                        class="border border-gray-300 rounded-md text-sm w-full p-2"
                      />
                    </div>
                    <div class="flex gap-3 justify-between">
                      <div class="flex flex-col gap-3 w-full">
                        <label for="program_name" class="text-sm flex gap-2"
                          >Program Name <span class="text-red-400">*</span>
                        </label>
                        <select
                          v-model="program_id"
                          @change="getProgramsFilter(program_id)"
                          required
                          class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3"
                        >
                          <option value="" disabled>Select Program</option>
                          <option
                            v-for="program in programs"
                            :key="program.id"
                            :value="program.id"
                          >
                            {{ program.name }}
                          </option>
                        </select>
                      </div>

                      <!-- Department -->
                      <div class="flex flex-col gap-3 w-full">
                        <label for="department" class="text-sm flex gap-2"
                          >Departments <span class="text-red-400">*</span>
                        </label>
                        <select
                          v-model="department_id"
                          @change="
                            getInstructorListByFilter(department_id);
                            getSemesterFilter(department_id);
                          "
                          required
                          class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3"
                        >
                          <option value="" disabled>Select Department</option>
                          <option
                            v-for="department in departments"
                            :key="department.id"
                            :value="department.id"
                          >
                            {{ department.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                      <div class="flex flex-col gap-3">
                        <label class="text-sm flex gap-2"
                          >Semester <span class="text-red-400">*</span>
                        </label>
                        <select
                          v-model="semester_id"
                          required
                          class="rounded-lg text-sm w-full p-3"
                        >
                          <option value="" disabled>Select Semester</option>
                          <option
                            v-for="semester in semetser_list"
                            :key="semester.id"
                            :value="semester.id"
                          >
                            {{ semester.semester }}
                          </option>
                        </select>
                      </div>
                      <!-- Section -->
                      <div class="flex flex-col gap-3">
                        <label class="text-sm flex gap-2"
                          >Section <span class="text-red-400">*</span>
                        </label>

                        <select
                          v-model="section_id"
                          required
                          class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3"
                        >
                          <option value="" disabled>Select Section</option>
                          <option
                            v-for="section in sections"
                            :key="section.id"
                            :value="section.id"
                          >
                            {{ section.name }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- faculty -->
                    <div class="flex flex-col gap-3 w-full">
                      <label class="text-sm font-medium">Select Faculty</label>
                      <ul
                        class="w-full border rounded-lg shadow-md h-[150px] overflow-y-auto mt-1 p-2 space-y-2"
                        :class="
                          instructor_lists.length === 0
                            ? 'bg-gray-200'
                            : 'bg-white'
                        "
                      >
                        <li
                          v-for="instructor in instructor_lists"
                          :key="instructor.id"
                          class="flex items-center gap-2 cursor-pointer"
                        >
                          <input
                            type="checkbox"
                            :value="instructor.id"
                            v-model="instructor_id"
                            class="form-checkbox accent-blue-600"
                          />
                          <span>{{ instructor.user.email }}</span>
                        </li>
                      </ul>
                    </div>

                    <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                      <div class="flex flex-col gap-3">
                        <label
                          for="course_code"
                          class="text-sm flex gap-1 items-center"
                          >Course Code <span class="text-red-400">*</span>
                          <div class="relative group">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-6a.75.75 0 011.5 0v1.25a.75.75 0 01-1.5 0V12zm0-6a.75.75 0 011.5 0v3a.75.75 0 01-1.5 0V6z"
                                clip-rule="evenodd"
                              />
                            </svg>
                            <div
                              class="absolute z-10 hidden group-hover:block w-48 rounded bg-gray-800 p-2 text-xs text-white top-5 left-16 -translate-x-1/2"
                            >
                              Unique course code
                            </div>
                          </div>
                        </label>
                        <input
                          id="course_code"
                          type="text"
                          maxlength="10"
                          required
                          @input="validateCourseCode"
                          class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                        />
                        <p
                          v-if="errorMessage"
                          class="text-red-500 text-sm mt-1"
                        >
                          {{ errorMessage }}
                        </p>
                        <p
                          v-if="errorgreenMessage"
                          class="text-green-500 text-sm mt-1"
                        >
                          {{ errorgreenMessage }}
                        </p>
                      </div>

                      <div class="flex flex-col gap-3">
                        <label for="category" class="text-sm flex gap-2"
                          >Course Type <span class="text-red-400">*</span>
                        </label>
                        <select
                          id="course_type"
                          required
                          class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                        >
                          <option value="" selected disabled>
                            Select Course Type
                          </option>
                          <option
                            v-for="type in courseTypeList"
                            :key="type.id"
                            :value="type.id"
                          >
                            {{ type.title }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="flex items-center gap-2">
                      <label for="checkbox">Published</label>
                      <input
                        type="checkbox"
                        id="Published"
                        v-model="isPublished"
                      />
                    </div>
                  </div>
                  <div class="flex justify-between items-center py-2 lg:py-4">
                    <div>
                      <p class="text-green-400 text-xl" v-if="message">
                        {{ message }}
                      </p>
                    </div>
                    <div class="flex gap-3 items-center">
                      <button
                        :disabled="disable_submit == true"
                        :class="
                          this.disable_submit == true
                            ? 'bg-gray-200 text-black cursor-not-allowed'
                            : 'bg-blues hover:bg-blue-700 cursor-pointer text-white '
                        "
                        class="text-sm font-semibold rounded overflow-hidden px-4 py-2 "
                      >
                        Submit
                      </button>
                      <img
                        v-if="disable_submit"
                        src="@/assets/loading.gif"
                        alt="loading"
                        class="w-6 h-6 object-contain"
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import MarkdownPreview from "@uivjs/vue-markdown-preview";
import "@uivjs/vue-markdown-preview/markdown.css";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import Header from "@/components/Admin/Header.vue";

import FlashMessage from "@/components/FlashMessage.vue";
export default {
  name: "CoursePreview",
  props: ["course_id"],

  data() {
    return {
      loading: true,
      disable_submit: false,
      popupData2: [],
      convertpopup: false,
      promt_id: "",
      prompt_value: [],
      conversion_title: "",
      markdown: "",
      thumbnail: null,
      isPublished: "",
      submitpopup: false,
      genaicourse: false,
      genicourseid: "",
      courseedit: [],
      message: "",
      batch_id: 1,
      program_id: "",
      department_id: "",
      semester_id: "",
      section_id: "",
      programs: [],
      departments: [],
      semetser_list: [],
      sections: [],
      instructor_lists: [],
      courseTypeList: [],
      instructor_id: [],
      messages: {
        text: "",
        type: "null",
      },
    };
  },
  computed: mapGetters(["userInfo", "instructorInfo"]),
  components: {
    Header,
    QuillEditor,
    MarkdownPreview,
    FlashMessage,
  },
  created() {
    this.getGemini();
    this.getPrograms();
    this.sectionsGet();
    this.getCourseTypeList();
    console.log("course_id::::::::", this.course_id);
  },
  methods: {
    getPrograms() {
      axios
        .get(
          `${process.env.VUE_APP_API}/program-list/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          this.programs = res.data.data;
        });
    },
    getProgramsFilter(program_id) {
      axios
        .get(
          `${process.env.VUE_APP_API}/department-list/?Key=${this.userInfo.token_key}&program__id=${program_id}`
        )
        .then((res) => {
          this.departments = res.data.data;
        });
    },
    getInstructorListByFilter(department_id) {
      axios
        .get(
          `${process.env.VUE_APP_API}/instructor_all/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          console.log(res);
          this.instructor_lists = res.data.products;
        });
    },
    getSemesterFilter(department_id) {
      let batch_year = 1;
      axios
        .get(
          `${process.env.VUE_APP_API}/semetser-get/?Key=${this.userInfo.token_key}&department__id=${department_id}&batch__id=${batch_year}`
        )
        .then((res) => {
          this.semetser_list = res.data.data;
        });
    },
    sectionsGet() {
      axios
        .get(
          `${process.env.VUE_APP_API}/section-list/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          this.sections = res.data.data;
        });
    },
    getCourseTypeList() {
      axios
        .get(
          `${process.env.VUE_APP_API}/course_type/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          this.courseTypeList = res.data.data;
        });
    },

    goBack() {
      this.$router.push({
        name: "PromptList",
      });
    },
    getGemini() {
      axios
        .get(
          `${process.env.VUE_APP_API}/gemini/list/?Key=${this.userInfo.token_key}&courseprompt=${this.course_id}`
        )
        .then((response) => {
          if (response.status == 200) {
            console.log("id////850", response.data);
            this.popupData2 = response.data.data[0];
            this.promt_id = this.popupData2.courseprompt;
            this.markdown = response.data.data[0].course;
            this.genicourseid = response.data.data[0].id;
            setTimeout(() => {
              this.loading = false;
            }, 1000);
            console.log("this.promt_id", this.promt_id);
            console.log(" this.popupData2", this.popupData2);
            console.log("id", response.data.data[0].id);
          } else {
            console.log("error on api");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    convertcourse() {
      this.convertpopup = true;
      this.promptList();
    },
    promptList() {
      axios
        .get(
          `${process.env.VUE_APP_API}/courseprompt/get/?id=${this.promt_id}&Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.status == 200) {
            this.prompt_value = response.data.data;
            console.log("prompt_value", this.prompt_value);
            this.conversion_title = response.data.data[0].title;
            console.log("conversion_title", this.conversion_title);
          } else {
            console.log("error on api");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    genaicourseedit() {
      const genaidata = {
        course: this.markdown,
      };
      console.log("genaidata", genaidata);
      console.log("genaidata", this.genicourseid);

      axios
        .patch(
          `${process.env.VUE_APP_API}/genaicourse/update-course/${this.genicourseid}/`,
          genaidata
        )
        .then((response) => {
          console.log("datashow", response);
          if (response.status == 200) {
            this.popupData2 = response.data;
            this.message = response.data.message;
            setTimeout(() => {
              this.message = "";
              this.genaicourse = false;
            }, 3000);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // handleFileUpload(event) {
    //   this.thumbnail = event.target.files[0];
    // },

    async createCourse(e) {
      const formData = new FormData();
      if (e.target.elements.thumbnail.files.length > 0) {
        var thumbnailVal = e.target.elements.thumbnail.files[0];
        formData.append("thumbnail", thumbnailVal);
      }
      formData.append("course_title_data", this.conversion_title);
      formData.append("category", this.markdown);
      // formData.append("thumbnail", this.thumbnail);
      // formData.append("status", this.isPublished);
      // When preparing formData
      formData.append("status", this.isPublished ? "True" : "False");
      formData.append("batch", this.batch_id);
      formData.append("program", this.program_id);
      formData.append("department", this.department_id);
      formData.append("semester", this.semester_id);

      formData.append("sections", this.section_id);
      formData.append("instructor", this.instructor_id);
      formData.append("courseType", e.target.elements.course_type.value);
      formData.append("organization_id", this.userInfo.organizes_id);
      formData.append("coursecode", e.target.elements.course_code.value);

      console.log("formData", formData);
      console.log("promtid", this.promt_id);
    this.disable_submit = true;
      await axios
        .post(
          `${process.env.VUE_APP_API}/upload-course-content/${this.promt_id}/`,
          formData
        )

        .then((response) => {
          // console.log("response", response);
          if (response.status == 200) {
            this.newcourseid = response.data;
            console.log("upload?////", this.newcourseid);
            // this.message = response.data.message;
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            console.log("message", this.message);

            setTimeout(() => {

              // this.message = "";

              this.messages = {
                text: "",
                type: "",
              };

                this.disable_submit = false;
              this.convertpopup = false;
            }, 3000);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
                this.disable_submit = false;
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        })
        .catch((err) => {
          console.log("error", err);
        });

      // this.convertpopup = false;
      // this.submitpopup = true;
      // setTimeout(() => {
      //   this.submitpopup = false;
      // }, 3000);
    },
  },
};
</script>

<style></style>
